
import { Toaster } from "react-hot-toast";

const GlobalToaster = () => {
  return (
    <Toaster
      position="top-center"
      toastOptions={{
        duration: 3000,
        style: {
          background: "#FAF7FC",
          color: "#2A1038",
          borderRadius: "14px",
          padding: "14px 18px",
          fontFamily: "Poppins, sans-serif",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
          border: "1px solid #E6D9EE",
        },

        success: {
          iconTheme: {
            primary: "#42035d",
            secondary: "#FFFFFF",
          },
          style: {
            background: "#F4EDF8",
            borderLeft: "5px solid #42035d",
          },
        },

        error: {
          iconTheme: {
            primary: "#E53935",
            secondary: "#FFFFFF",
          },
          style: {
            background: "#FDEEEE",
            borderLeft: "5px solid #E53935",
          },
        },

        loading: {
          iconTheme: {
            primary: "#42035d",
            secondary: "#FFFFFF",
          },
          style: {
            background: "#F6F0FA",
            borderLeft: "5px solid #42035d",
          },
        },
      }}
    />
  );
};

export default GlobalToaster;
